<app-lcl-card cardTitle="MENU.CONTACTS">
  <ng-container body>
    <div class="lcl-contacts">
      <div class="lcl-contacts-item">
        <desktop-summary-entity
          [entity]="shipment?.shipper"
          [cardTitle]="'LABELS.SHIPPER_EXPORTER'"
          [isShowIdentifier]="false"
          [isShowEmail]="true"
          [isShowPhone]="true"
          [entityCode]="enumEntityModelCode.SHIPPER"
          [isEditMode]="isEditable"
          [isRequired]="true"
          [isSkipValidation]="isSkipValidation"
          [validationKeys]="validationKeys"
          (edit)="onEditShipper()"
        ></desktop-summary-entity>
      </div>

      <div class="lcl-contacts-item">
        <desktop-summary-entity
          [entity]="shipment?.consignee"
          [cardTitle]="'LABELS.CONSIGNEE_RECEIVER'"
          [isShowIdentifier]="false"
          [isShowEmail]="true"
          [isShowPhone]="true"
          [entityCode]="enumEntityModelCode.CONSIGNEE"
          [isEditMode]="isEditable"
          [isRequired]="true"
          [validationKeys]="validationKeys"
          [isSkipValidation]="isSkipValidation"
          (edit)="onEditConsignee()"
        ></desktop-summary-entity>
      </div>

      <div class="lcl-contacts-item">
        <desktop-summary-entity
          [entity]="shipment?.notifyParty"
          [cardTitle]="'LABELS.NOTIFY_PARTY'"
          [isShowIdentifier]="false"
          [isShowEmail]="true"
          [isShowPhone]="true"
          [entityCode]="enumEntityModelCode.NOTIFY_PARTY"
          [isEditMode]="isEditable"
          [isLastInRow]="true"
          [isRequired]="false"
          [addHintText]="'LABELS.NOTIFY_PARTY_HINT'"
          [validationKeys]="validationKeys"
          [isSkipValidation]="isSkipValidation"
          (edit)="onEditNotifyParty()"
        ></desktop-summary-entity>
      </div>
    </div>
  </ng-container>
</app-lcl-card>
